import { render, staticRenderFns } from "./MainContentComponent.vue?vue&type=template&id=1db7383d&scoped=true"
import script from "./MainContentComponent.vue?vue&type=script&lang=js"
export * from "./MainContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7383d",
  null
  
)

export default component.exports